
<div class="dropdown">
  <button @click="teleport.dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle btn-icon clear-area controllers">
    <icon class="kebab"></icon>
    <span class="sr-only">More Actions Dropdown</span>
  </button>
  <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ruleMoreOptions">
    <li v-if="canMoveUp">
      <button class="dropdown-item" @click="moveUp">Move Up</button>
    </li>
    <li v-if="canMoveDown">
      <button class="dropdown-item" @click="moveDown">Move Down</button>
    </li>
    <li v-if="canMoveOutsideBefore">
      <button class="dropdown-item" @click="moveOutsideBefore">Move outside before this block</button>
    </li>
    <li v-if="canMoveOutsideAfter">
      <button class="dropdown-item" @click="moveOutsideAfter">Move outside after this block</button>
    </li>
    <li v-if="canMoveInsideBefore">
      <button class="dropdown-item" @click="moveInsideBefore">Move inside the block above</button>
    </li>
    <li v-if="canMoveInsideAfter">
      <button class="dropdown-item" @click="moveInsideAfter">Move inside the block below</button>
    </li>
    <li v-if="canMoveUp || canMoveDown || canMoveOutsideBefore || canMoveOutsideAfter || canMoveInsideAfter">
      <hr>
    </li>
    <li>
      <button class="dropdown-item" @click="addConditionBelow">Add condition below</button>
    </li>
    <li>
      <button class="dropdown-item" @click="addConditionAbove">Add condition above</button>
    </li>
    <li>
      <button class="dropdown-item" @click="addConditionSetBelow">Add condition block below</button>
    </li>
    <li>
      <button class="dropdown-item" @click="addConditionSetAbove">Add condition block above</button>
    </li>
    <li>
      <hr>
    </li>
    <li>
      <button class="dropdown-item" @click="deleteRule">
        Delete {{isRule ? 'Item' : 'Block'}}
      </button>
    </li>
  </ul>
</div>
